import { render } from "./index.vue?vue&type=template&id=7cbc52f0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7cbc52f0&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cbc52f0"],['__file',"vendor/vvg/forum/resources/vue/topic/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7cbc52f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7cbc52f0', __exports__)) {
    console.log('reload')
    api.reload('7cbc52f0', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=7cbc52f0&scoped=true", () => {
    console.log('re-render')
    api.rerender('7cbc52f0', render)
  })

}


export default __exports__